import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import styled from "@mui/material/styles/styled";

export const StyledBox = styled("div")(({ theme }) => ({
  marginBottom: 60,
  overflow: "hidden",
  backgroundColor: theme.palette.primary[100],
}));
export const StyledGrid = styled(Grid)(({ theme }) => ({
  maxWidth: 1280,
  margin: "auto",
  alignItems: "center",
  [theme.breakpoints.down("sm")]: {
    flexDirection: "column-reverse",
  },
}));
export const GridItemOne = styled(Grid)(({ theme }) => ({
  padding: 20,
  "& .titleBox": {
    marginBottom: 16,
    "& h1": {
      fontSize: 46,
      fontWeight: 800,
      lineHeight: 1.3,
    },
    "& p": {
      maxWidth: 624,
      fontSize: 20,
    },
  },
  [theme.breakpoints.down("md")]: {
    "& .titleBox": {
      "& h1": {
        fontSize: 40,
        fontWeight: 700,
      },
    },
    "& p": {
      maxWidth: 400,
      fontSize: 18,
    },
  },
  [theme.breakpoints.down("sm")]: {
    textAlign: "center",
    "& .titleBox": {
      textAlign: "center",
      "& h1": {
        fontSize: 30,
        fontWeight: 600,
      },
      "& p": {
        fontSize: 14,
      },
    },
  },
}));
export const CarouselButton = styled(Button)(({ theme }) => ({
  color: "black",
  border: "1px solid black",
  fontWeight: 400,
  fontSize: "16px",
  borderRadius: 8,
  backgroundColor: "transparent",
  "@media only screen and (max-width: 768px)": {
    marginTop: "70px",
  },
}));
export const GridItemTwo = styled(Grid)(({ theme }) => ({
  [theme.breakpoints.down("sm")]: {
    display: "none",
  },
})); // USED IN SECTION 2
